import { Request } from "../../Servidor/Request";

export class FarmClassificationTpProductRequest {
    private sgepclassificacaotpprodagropecuario: number;
    private nome: string;

    constructor (sgepclassificacaotpprodagropecuario:number, nome: string){
        this.sgepclassificacaotpprodagropecuario = sgepclassificacaotpprodagropecuario;
        this.nome = nome;
    }

    /**
     * Getter sgepclassificacaotpprodagropecuario
     * @return {number}
     */
    public getSgeptpprodagropecuario(): number {
        return this.sgepclassificacaotpprodagropecuario;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}
export class FarmClassificationTpProductStructRequest {
    private sgepclassificacaotpprodagropecuario: number;

    constructor (sgepclassificacaotpprodagropecuario: number){
        this.sgepclassificacaotpprodagropecuario = sgepclassificacaotpprodagropecuario;
    }

    /**
     * Getter sgepclassificacaotpprodagropecuario
     * @return {number}
     */
    public getSgepclassificacaotpprodagropecuario(): number {
        return this.sgepclassificacaotpprodagropecuario;
    }
}

export class FarmClassificationTpProductInteractor {
    public fetchSave(request: FarmClassificationTpProductRequest): PromiseLike<Boolean>{
        return new Promise ((res,rej) => {
            return new Request().requestPost("basico/classificacao-tipo-produto-agropecuario/salvar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                      Mensagem:"Erro ao conectar!"  
                    })
                }

                let response = rs.Status == "Sucesso!"
                res(response) 
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: FarmClassificationTpProductStructRequest): PromiseLike<FarmClassificationTpProductRequest>{
        return new Promise ((res, rej) => {
            return new Request().requestPost("basico/classificacao-tipo-produto-agropecuario/buscar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem:"Erro ao conectar!"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}
